import React from 'react';
typeof window !== 'undefined' && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = '2.10.0');
import { createPortal } from 'react-dom';
import { Link } from '../Link';
import { VisuallyHidden } from '../VisuallyHidden';
import * as S from './styles';
const DEFAULT_DURATION = 5 * 1000; // 5 segundos
/**
 * Componente Toast do Design System OLX
 */
export class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.timeout = 0;
    this.getActionByProps = (previousShow, show) => {
      if (!previousShow && show) return 'mounting';
      if (previousShow && !show) return 'unmounting';
      return null;
    };
    this.closeToast = () => {
      clearTimeout(this.timeout);
      this.props.onClose();
    };
    this.initTimer = () => {
      const {
        duration = DEFAULT_DURATION
      } = this.props;
      if (duration !== 'infinite' && duration > 0) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(this.closeToast, duration);
      }
    };
    this.renderRightContent = () => {
      var _a;
      const {
        action,
        closable
      } = this.props;
      if (action && action.href && action.text) return React.createElement(Link, {
        marginLeft: "--spacing-1",
        href: action.href,
        onClick: (_a = action.onClick) !== null && _a !== void 0 ? _a : undefined,
        size: "caption",
        variant: "inverted"
      }, action.text);
      if (closable) return React.createElement(S.CloseButton, {
        onClick: this.closeToast,
        "data-ds-component": "DS-Toast-Button"
      }, React.createElement(S.CloseIcon, {
        "aria-hidden": "true",
        "data-testid": "ds-icon-system-x",
        size: 24
      }), React.createElement(VisuallyHidden, null, "Fechar"));
      return null;
    };
    this.state = {
      isClient: false,
      unmount: !props.visible
    };
  }
  static getDerivedStateFromProps(props, state) {
    if (props.visible && state.unmount) {
      return {
        unmount: false
      };
    }
    return null;
  }
  // Não renderiza o componente quando está no server side (SSR)
  // Pois utilizar o createPortal para fazer append do componente no document.body
  componentDidMount() {
    this.setState({
      isClient: true
    });
    if (this.props.visible) {
      this.initTimer();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      visible: previousVisible
    } = prevProps;
    const {
      visible
    } = this.props;
    const trigger = this.getActionByProps(previousVisible, visible);
    // Gatilho para mostrar
    if (trigger === 'mounting') {
      this.initTimer();
    }
    if (trigger === 'unmounting') {
      setTimeout(() => this.setState({
        unmount: true
      }), 1000);
    }
  }
  // Limpa o timeout para que não haja uma chamada para a função closeToast
  // caso o componente seja desmontado antes do timeout fazer a chamada.
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  render() {
    const {
      isClient,
      unmount
    } = this.state;
    const {
      icon,
      visible,
      text
    } = this.props;
    if (!isClient || unmount) return null;
    return createPortal(React.createElement(S.ToastWrapper, {
      role: "alert",
      "data-ds-component": "DS-Toast"
    }, React.createElement(S.ToastBody, {
      type: "elevated",
      paddingTop: "--spacing-2",
      paddingRight: "--spacing-3",
      paddingBottom: "--spacing-2",
      paddingLeft: "--spacing-3",
      visible: visible
    }, icon && React.createElement(S.IconWrapper, null, icon), React.createElement(S.ToastText, null, text), this.renderRightContent())), document.body);
  }
}
Toast.defaultProps = {
  visible: false,
  duration: DEFAULT_DURATION
};